export default __webpack_public_path__ + "assets/images/2036234d2a2b9aa7544015b2db2412a9.png";